import * as React from "react";
import { forwardRef } from "react";
const SvgIconNavigationArrowUpward = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#2C3032", fillOpacity: 0.6, fillRule: "evenodd", d: "m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8z" }));
const ForwardRef = forwardRef(SvgIconNavigationArrowUpward);
export default ForwardRef;
